import * as React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const ChronologyListTableHeader: React.FC = () => (
  <TableHeader>
    <TableRow className="rounded-t-xl">
      <TableHead className="w-[180px] bg-gray-50/80 py-3 pl-6">Created</TableHead>
      <TableHead className="min-w-[300px] bg-gray-50/80 py-3">Details</TableHead>
      <TableHead className="hidden min-w-[280px] bg-gray-50/80 py-3 lg:table-cell">Owner</TableHead>
      <TableHead className="w-[100px] bg-gray-50/80 py-3 pr-6 text-right">Actions</TableHead>
    </TableRow>
  </TableHeader>
);
